import type { TelegramClient } from "telegram";
import type { NextBatchItem } from "@tg/shared";
import { loadTg } from "./tglib";

// Rebuild an InputPeer from cached peer_id + access_hash (zero network). On
// rejection, fall back to resolving by username; otherwise signal unresolvable.
export async function toInputPeer(client: TelegramClient, t: NextBatchItem): Promise<unknown> {
  const { Api, returnBigInt } = await loadTg();
  const id = returnBigInt(t.peerId);
  const hash = returnBigInt(t.accessHash ?? "0");

  try {
    switch (t.peerType) {
      case "channel":
      case "supergroup":
        return new Api.InputPeerChannel({ channelId: id, accessHash: hash });
      case "user":
      case "bot":
        return new Api.InputPeerUser({ userId: id, accessHash: hash });
      case "group":
        return new Api.InputPeerChat({ chatId: id });
    }
  } catch {
    /* fall through to username resolution */
  }

  if (t.username) {
    return client.getInputEntity(t.username);
  }
  const err = new Error("ENTITY_UNRESOLVABLE");
  (err as { errorMessage?: string }).errorMessage = "ENTITY_UNRESOLVABLE";
  throw err;
}
